import styled, { css } from 'styled-components'
import Tooltip from '../Tooltip'

interface ContainerProps {
  isFocused: boolean
  isFilled: boolean
  isErrored: boolean
  color?: string
  annotation?: string
}

export const Container = styled.div<ContainerProps>`
  padding: 1rem;
  width: 100%;
  border-radius: 4px;
  border: solid 1px
    ${(props) => (props.color ? props.color : `rgb(${props.theme.component.accent})`)};
  ${(props) =>
    props.color &&
    css`
      color: ${props.color} !important;
    `};

  ${(props) =>
    props.isErrored &&
    css`
      color: #c53030;
      border-color: #c53030;

      svg {
        color: #c53030 !important;
      }
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: #ff6600;
      border-color: #ff6600;

      svg {
        color: #ff6600 !important;
      }
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: #ff6600;

      svg {
        color: #ff6600 !important;
      }
    `}

  display: flex;
  align-items: center;

  textarea {
    background: transparent;
    flex: 1;
    border: 0;
    font-size: 1rem;
    line-height: 1.25rem;
    font-weight: 500;
    max-height: 10rem;
    max-width: 73rem;
    overflow-y: auto;
    color: ${(props) => (props.color ? props.color : `rgb(${props.theme.grayscale[200]})`)};
    ${(props) =>
      props.annotation === 'modal' &&
      css`
        resize: none;
      `}
  }

  & + div {
    margin-top: 8px;
  }

  svg {
    margin-right: 16px;
    ${(props) =>
      props.color &&
      css`
        color: ${props.color};
      `}
  }

  button {
    background: transparent;
    border: none;

    svg {
      margin: 0;
      ${(props) =>
        props.color &&
        css`
          color: ${props.color};
        `}
    }
  }
  @media only screen and (max-width: 498px) {
    padding: 0.5rem;
  }
`

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`
